import React from "react";
import "./Projects.css";
import ProjectSite from "./ProjectSite";
import dlight from "../../Image/dlight.PNG";
import one from "../../Image/one.PNG";
import two from "../../Image/twoo.png";
import four from "../../Image/fourr.png";
import six from "../../Image/six.PNG";
import devpost from "../../Image/devpost.PNG";

const Projects = () => {
  const data = [
    {
      Des: "An immersive web-based game educating users on online safety. Seamless UI/UX and scalable data handling.",
      ProjectLink: "https://chainlink-hack-frontend.vercel.app/",
      GithubLink: "https://devpost.com/haywhyvilla/challenges",
      image: devpost,
      tags: ["React", "Blockchain", "Tailwind"]
    },
    {
      Des: "UBA Interbank Transfer Switching Service. Built with robust secure architectures and high-performance financial API integrations.",
      ProjectLink: "https://interbank-transfer-switching-service-zusv.vercel.app/",
      GithubLink: "https://github.com/INFOMETICS-UBA/Interbank-Transfer-Switching-Service.git",
      image: four,
      tags: ["TypeScript", "API", "Finance"]
    },
    {
      Des: "AI food delivery app providing intelligent routing and personalized meal recommendations.",
      ProjectLink: "https://olatfood.netlify.app/",
      GithubLink: "https://github.com/haywhyvilla/Olatfood-PROJECT",
      image: six,
      tags: ["AI", "React", "Node.js"]
    },
    {
      Des: "Empowering businesses to offer digital programs and fintech services seamlessly to customers.",
      ProjectLink: "https://myfrontendintership.netlify.app/",
      GithubLink: "https://github.com/haywhyvilla/FIntechfrontendtask",
      image: one,
      tags: ["Fintech", "UI/UX"]
    },
    {
      Des: "A virtual platform that helps in the development and growth of the digital economy for local users.",
      ProjectLink: "https://thrida.com/",
      GithubLink: "https://github.com/haywhyvilla/mythrida",
      image: two,
      tags: ["Platform", "Scaling"]
    },
    {
      Des: "An online tutoring platform connecting parents or students with experienced tutors globally.",
      ProjectLink: "https://www.d-lightertutor.com/",
      GithubLink: "https://medium.com/@dlightertutor",
      image: dlight,
      tags: ["EdTech", "WebRTC"]
    },
  ];
  return (
    <div className="container section-project" id="project">
      <div className="section-title">
        <h2>Featured Projects</h2>
        <span className="line"></span>
      </div>

      <div className="projects-grid">
        {data.map((item, index) => (
          <div className="project-col" key={index}>
            <ProjectSite {...item} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Projects;
